import isDefaultAsset from './is-default-asset';
import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
} from '../../constants/block-background-attributes';
import { BACKGROUND_HIDDEN } from '../../constants/display-options';

const handleBackgroundImageAsFallback = ({
  originalBlockNode,
  destinationBlockNode,
  originalOptionalChildren,
  destinationOptionalChildren,
  backgroundOption,
  displayOptions,
}) => {
  if (!backgroundOption) return false;

  if (
    !destinationBlockNode.hasAttribute(BACKGROUND_IMAGE_ATTRIBUTE) ||
    originalBlockNode.hasAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE)
  ) {
    return false;
  }

  const backgroundHiddenOption = displayOptions.find(({ id }) => id === BACKGROUND_HIDDEN);

  if (!backgroundHiddenOption?.isEnabled) {
    return false;
  }

  const originalBlockMedia = originalOptionalChildren.find((el) => el.id === 'block_media');
  const destinationBlockMedia = destinationOptionalChildren.find((el) => el.id === 'block_media');

  if (!originalBlockMedia || destinationBlockMedia) return false;

  const { querySelector } = originalBlockMedia;
  const blockMediaNode = originalBlockNode.querySelector(querySelector);

  if (!blockMediaNode) return false;

  const sourcePicture = blockMediaNode.querySelector('img');

  if (!sourcePicture) return false;

  const backgroundImageValue = backgroundOption.values[BACKGROUND_IMAGE_ATTRIBUTE];

  if (isDefaultAsset(backgroundImageValue)) return false;

  destinationBlockNode.setAttribute(BACKGROUND_IMAGE_ATTRIBUTE, backgroundImageValue);

  return true;
};

export default handleBackgroundImageAsFallback;
